import { ComponentWrapperProps } from "@made-people/blueprint-component-wrapper";

export const ComponentWrapper: ComponentWrapperProps = {
  layout: {
    position: {
      applyPosition: "true",
      maxWidth: "xl",
    },
    spacing: {
      y: {
        initial: "2xl",
        md: "2xl",
        lg: "2xl",
      },
      x: {
        initial: "md",
        md: "lg",
        lg: "xl",
      },
    },
  },
};
